//App.js
import { useCallback, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Login from "./pages/Login";
import { seteditedNewNodes } from "./redux/nodesSlice";
import {
  selectisEdit,
  selectSave,
  setIsEdit,
} from "./redux/nodePositionedSlice";
// import LoginViaSSO from "./pages/LoginViaSSO";
import AuthCallback from "./pages/AuthCallback";
import PrivateRoutes from "./pages/PrivateRoutes";
import LoginErrorPage from "./pages/LoginErrorPage";
import { connectWebSocket, disconnectWebSocket } from "./redux/websocketSlice";
import { selectAdmin, selectDevice } from "./redux/adminSlice";
import { useUpdatePositionsMutation } from "./redux/organizationApi";
import NotFound from "./pages/NotFound";

function App() {
  const dispatch = useDispatch();
  const isEdit = useSelector(selectisEdit);
  const autoSaave = useSelector(selectSave);
  const location = useLocation();
  const admin = useSelector(selectAdmin);
  const deviceId = useSelector(selectDevice);
  const [updatePositions] = useUpdatePositionsMutation();

  const position = useCallback(
    async (orgs) => {
      if (!orgs || orgs.length === 0) {
        return;
      }
      try {
        const updatedData = await updatePositions(orgs).unwrap();
        // if (updatedData?.updatedNodes) {
        //   dispatch(seteditedNewNodes(updatedData.updatedNodes));
        // }
        toast.success("Chart updated successfully");
        if (isEdit === true) {
          dispatch(setIsEdit(!isEdit));
        }
      } catch (error) {
        toast.error(
          error?.data?.message || error?.error || "Failed to update positions"
        );
        dispatch(setIsEdit(false));
      }
    },
    [dispatch, isEdit, updatePositions]
  );
  useEffect(() => {
    const filterdata = autoSaave?.map((item) => ({
      id: item.id,
      position: item?.position,
    }));
    if (
      isEdit === true &&
      location?.pathname !== "/admin/Organisational-Chart"
    ) {
      position(filterdata, true);
    }
  }, [isEdit, location?.pathname, position]);

  useEffect(() => {

    if (admin && deviceId) {
      dispatch(disconnectWebSocket());
      setTimeout(() => {
        dispatch(connectWebSocket());
      }, 100);
      return () => {
        dispatch(disconnectWebSocket());
      };
    }
  }, [admin, deviceId, dispatch]);
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        {/* <Route path="/login-via-sso" element={<LoginViaSSO />} /> */}
        <Route path="/login-error" element={<LoginErrorPage />} />
        <Route path="/auth-callback" element={<AuthCallback />} />
        <Route path="/admin/*" element={<PrivateRoutes />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <ToastContainer position="bottom-right" />
    </>
  );
}

export default App;






